import AlbumPhotos from './album-photos'

export default AlbumPhotos